export const vehicleReportHeaders = {
   header: [
      { name: 'marca', text: 'Marca', position: 0 },
      { name: 'modelo', text: 'Modelo', position: 1 },
      { name: 'ativo', text: 'Ativo', position: 2 },
      { name: 'dataCriacao', text: 'Data de Criação', position: 3 },
      { name: 'dataAlteracao', text: 'Data de Alteração', position: 4 }
   ]
};

export const defaultLoader = [
   {
      height: '20px'
   },
   {
      height: '20px'
   },
   {
      height: '20px'
   },
   {
      height: '20px'
   },
   {
      height: '20px'
   }
]